const columns = [
  {
    title: '菜单名称',
    key: 'title',
    width: 500,
    tree: true
  },
  {
    title: '菜单编号',
    key: 'rs_code'
  },
  {
    title: '操作',
    slot: 'iconfont',
    width: 200,
    iconClass: [
      {name: 'ys-iconadd', code: '增加', status: 1, type: 'add', size: 'small', Pname: 'resources_menu_tab_add_btn'},
      {name: 'ys-iconfuzhi', code: '复制', status: 1, Pname: 'resources_menu_tab_copy_btn'},
      {name: 'ys-iconbianji', code: '编辑', status: 1, Pname: 'resources_menu_tab_edit_btn'},
      {name: 'ys-iconlajitongbeifen', code: '删除', status: 1, Pname: 'resources_menu_tab_delate_btn'}
    ]
  },
]

export default columns